import angular from "angular"
import { trimStart } from "lodash"
import moment from "moment"
import "./base"

declare var jQuery: JQueryStatic

require('angular-resource')
// quire(" "bootstrap-angular")
require('angular-i18n/es')
require('angular-cookies')
require('angular-local-storage')
require('angular-animate')
require('@uirouter/angularjs')

export var $uniMainModule = angular.module("uniMain", [
    "ngResource",
    "ngCookies",
    "LocalStorageModule",
    "ui.router"
])

console.log('uni-main!!!')
console.log('angular.version', angular.version)
console.log('jquery.version', jQuery.fn)
// console.log("window.jQuery.fn", require("window").jQuery.fn)
console.log('moment', moment())
console.log('moment', moment().format('dddd YYYY MMMM '))
console.log('moment3', moment().format('DD MMM YYYY HH:mm'))
console.log('lodash>' + trimStart('    -    foo ---'))
